import useAppSelector from './useAppSelector.js'

export default useAppSelector
